export const prefixTable = 'administration.monitor.evaluations.table'
export const prefixColumns = `${prefixTable}.columns`
export const prefixHeaders = `${prefixTable}.headers`

export enum EvaluationsColumns {
  name = 'name',
  status = 'status',
  score = 'score',
  action = 'action',
}
